import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'

export default class FormParentEligibilityController extends Controller {
  declare insuranceParentMemberIdTarget: HTMLInputElement
  static targets = ['insuranceParentMemberId']

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.insuranceParentMemberIdTarget.focus()
    this.setInitialValues()
  }

  setInitialValues() {
    if (!this.checkoutOutlet.signupData.eligibility) return
    if (
      this.checkoutOutlet.signupData.eligibility?.eligibility_type !== 'parent'
    )
      return

    const { insurance_parent_member_id } =
      this.checkoutOutlet.signupData.eligibility

    this.insuranceParentMemberIdTarget.value = insurance_parent_member_id
  }
}
